import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AdminAuthProvider } from "./Admin/contexts/AdminAuthContext";

import GameContainer from "./Game/GameContainer";
import AdminLogin from "./Admin/components/AdminLogin";
import AdminDashboard from "./Admin/components/AdminDashboard";
import CreateOrUpdateGame from "./Admin/components/CreateOrUpdateGame/CreateOrUpdateGame";

import "./App.scss";

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Admin routes wrapped with AdminAuthProvider */}
            <Route
              path="/admin/*"
              element={
                <AdminAuthProvider>
                  <Routes>
                    <Route path="/" element={<AdminLogin />} />
                    <Route path="/dashboard" element={<AdminDashboard />} />
                    <Route
                      path="/games/create"
                      element={<CreateOrUpdateGame />}
                    />
                    <Route
                      path="/games/edit/:gameId"
                      element={<CreateOrUpdateGame />}
                    />
                  </Routes>
                </AdminAuthProvider>
              }
            />

            {/* Public routes */}
            <Route path="/:gameId" element={<GameContainer />} />
            <Route path="/" element={<GameContainer />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
